import type { IClientKPIs } from '@/interfaces'

export class ClientKPIs implements IClientKPIs {
	countJobsCFY: number
	countJobsPFY: number
	countJobsTotal: number
	countJobsActive: number
	countQuotesOpenTotal: number
	countQuotesOpenDraft: number
	countQuotesOpenEstimatePending: number
	countQuotesOpenEstimateComplete: number
	countQuotesOpenApprovalPending: number
	countQuotesOpenApproved: number
	countQuotesOpenSentToClient: number
	sumQuotesOpen: number
	sumJobsContractedCFY: number
	sumJobsContractedPFY: number
	sumJobsInvoicedCFY: number
	sumJobsInvoicedPFY: number
	clientARBalance: number
	sumJobsUnbilled: number
	sumJobsUncontracted: number

	constructor({
		countJobsCFY = 0,
		countJobsPFY = 0,
		countJobsTotal = 0,
		countJobsActive = 0,
		countQuotesOpenTotal = 0,
		countQuotesOpenDraft = 0,
		countQuotesOpenEstimatePending = 0,
		countQuotesOpenEstimateComplete = 0,
		countQuotesOpenApprovalPending = 0,
		countQuotesOpenApproved = 0,
		countQuotesOpenSentToClient = 0,
		sumQuotesOpen = 0,
		sumJobsContractedCFY = 0,
		sumJobsContractedPFY = 0,
		sumJobsInvoicedCFY = 0,
		sumJobsInvoicedPFY = 0,
		clientARBalance = 0,
		sumJobsUnbilled = 0,
		sumJobsUncontracted = 0
	}: Partial<IClientKPIs> = {}) {
		this.countJobsCFY = countJobsCFY
		this.countJobsPFY = countJobsPFY
		this.countJobsTotal = countJobsTotal
		this.countJobsActive = countJobsActive
		this.countQuotesOpenTotal = countQuotesOpenTotal
		this.countQuotesOpenDraft = countQuotesOpenDraft
		this.countQuotesOpenEstimatePending = countQuotesOpenEstimatePending
		this.countQuotesOpenEstimateComplete = countQuotesOpenEstimateComplete
		this.countQuotesOpenApprovalPending = countQuotesOpenApprovalPending
		this.countQuotesOpenApproved = countQuotesOpenApproved
		this.countQuotesOpenSentToClient = countQuotesOpenSentToClient
		this.sumQuotesOpen = sumQuotesOpen
		this.sumJobsContractedCFY = sumJobsContractedCFY
		this.sumJobsContractedPFY = sumJobsContractedPFY
		this.sumJobsInvoicedCFY = sumJobsInvoicedCFY
		this.sumJobsInvoicedPFY = sumJobsInvoicedPFY
		this.clientARBalance = clientARBalance
		this.sumJobsUnbilled = sumJobsUnbilled
		this.sumJobsUncontracted = sumJobsUncontracted
	}
}
